import { Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Shell from '../../../common/components/Shell/Shell';
import DigitalSignaturePresenter from './DigitalSignaturePresenter';
import DTOTraining from '../Training/DTOTraining';
import { DigitalSignature } from '../../../api/services/digitalSignatureService';
import { useAppSelector } from '../../../infra/hooks';
import toast from 'react-hot-toast';

function DigitalSignatureController() {
  const { t, i18n } = useTranslation();
  const [data, setData] = useState();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [count, setCount] = useState(0);
  const [search, setSearch] = useState<any>();
  const [open, close] = useState<any>(false);
  const [attachment, setAttachment] = useState<any>(null);
  const selector = useAppSelector((state) => state.authSlice);

  const getList = () => {
    DigitalSignature.getDigiSignatureList(
      selector?.emp_id,
      selector?.company_id,
      page,
      limit,
      search
    ).then((res: any) => {
      setData(res?.data)
      setCount(res?.totalCount)
    })
  }

  useEffect(() => {
    getList()
  }, [page, limit, search])

  const submitApplication = (payload: any, id: any) => {
    if (!payload) return toast.error('Attachment mandotory');
    const data = {
      attachment: payload,
      signedBy: selector.user_id,
      status: 2
    }
    DigitalSignature.updateDigiSignature(data, id).then((res: any) => {
      toast.success(res?.message)
      getList()
    }).catch((err: any) => {
      toast.success('error during upload signature')
    })
  }

  return (
    <Shell>
      <Grid
        container
        style={{
          maxWidth: 'auto',
          marginLeft: i18n.language == 'en' ? '7.25em' : '',
        }}
      >
        <DTOTraining />
        <DigitalSignaturePresenter
          trans={t}
          i18n={i18n}
          data={data}
          setSearch={setSearch}
          setPage={setPage}
          setLimit={setLimit}
          submit={submitApplication}
          count={count}
        />
      </Grid>
    </Shell>
  );
}
export default DigitalSignatureController;
